<template>
	<div class="btn-group" role="group" aria-label="Toggle the entry status">
		<button @click="toggleAccepted" class="btn btn-sm cursor:pointer" v-bind:class="{ 'btn-success' : acceptedFlag, 'btn-danger active' : !acceptedFlag }">{{ acceptedLabel }}</button>
		<button @click="toggleWithdrawn" class="btn btn-sm cursor:pointer" v-bind:class="{ 'active btn-warning' : withdrawnFlag , 'btn-default' : !withdrawnFlag}">{{ withdrawnLabel }}</button>
	</div>
</template>

<script>

export default {
	props: ['accepted', 'withdrawn', 'meet_entry_event_id'],
	data: function () {
		return {
			// meet_entry_event_id: this.meet_entry_event_id,
			acceptedFlag: this.accepted == 1 ? true : false,
			withdrawnFlag: this.withdrawn == 1 ? true : false
		}
	},
	computed: {
		acceptedLabel : function() {
			if (this.acceptedFlag == true) {
				return 'Accepted';
			}
			return 'Rejected';
			
		},
		withdrawnLabel : function() {
			if (this.withdrawnFlag == true) {
				return 'Withdrawn';
			}
			return 'Withdraw';
		}
	},
	methods: {
		updateStatusOnServer() {
			console.log('Updating acceptance status');

			axios.put(`/api/meet_entry/set_event_status/${this.meet_entry_event_id}?accepted=${this.acceptedFlag}&withdrawn=${this.withdrawnFlag}`).then((response) => {
				// this.times = response.data;
				console.log(response.data);
				this.acceptedFlag = response.data.accepted;
				this.withdrawnFlag = response.data.withdrawn;
			});
		},
		toggleAccepted() {
			console.log('Toggling acceptance status');
			this.acceptedFlag =  ! this.acceptedFlag;
			// If we are setting to "Accepted" we want to reset withdrawn status and...
			// if we are setting to "Rejected" then we can't have withdrawn
			// this.withdrawnFlag = false;
			this.updateStatusOnServer();
		},
		toggleWithdrawn() {
			console.log('Toggling withdrawal status');
			this.withdrawnFlag =  ! this.withdrawnFlag;
			// this.acceptedFlag = true;
			this.updateStatusOnServer();
		},
	},
	mounted() {

	}
}
</script>